import { useMemo } from "react";
import Role from "admin/types/interfaces/role";
import { SWRConfiguration } from "swr";
import yn from "yn";
import { useV1List } from "~/hooks/useV1List";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

const { VITE_SM_ENABLED, VITE_COST_MANAGEMENT_ENABLED } = import.meta.env;

const FUNCTIONAL_ROLE_IDS = [
  // these existing roles are unchanged and should be included in the new functional roles set
  "ce_implementation_manager",
  "user_manager",
  ...(yn(VITE_SM_ENABLED) ? ["study_manager", "study_group_coordinator"] : []),

  // new roles
  "functional_compute_user",
  "functional_data_downloader",
  "functional_dataset_creator",
  "dataset_admin",
  "functional_workbench_creator",
  "functional_manifold_superuser",
  "functional_ai_agents_user",
  "ai_agents_manager",
  ...(yn(VITE_COST_MANAGEMENT_ENABLED) ? ["functional_cost_manager"] : []),
];

const useRoles = (options?: SWRConfiguration) => {
  const { data, ...rest } = useV1List<Role>(`${ACCESS_CONTROLLER_V1}/roles`, options);

  const filteredRoles = useMemo(() => {
    if (!data) {
      return data;
    }
    return data.filter((role) => FUNCTIONAL_ROLE_IDS.includes(role.id));
  }, [data]);

  return {
    ...rest,
    data: filteredRoles,
  };
};

export default useRoles;
